import React from "react";
import { Tag } from "antd";

interface ProviderCardProps
{

      satellites?: any[];
      selectedSatellite?: any[];
      allProviders?: any[];
      selectedProvider?: any;
}

const ProviderCard: React.FC<ProviderCardProps> = ({
      satellites,
      selectedSatellite,
      allProviders,
      selectedProvider
}) =>
{
      const selectedSatellites = satellites?.filter((sat) =>
            selectedSatellite?.includes(sat.name)
      );
      let providerSelected: any = allProviders?.filter((itemF?: any) => itemF?.code === selectedProvider)


      return (
            <div className="pb-6 px-6">
                  <div className="bg-[var(--neutral-950)] rounded-lg text-white w-full p-3">

                        <div className="flex items-center gap-4">
                              {/* Logo */}
                              <div className="w-14 h-14 bg-[#1f2a3a] rounded-sm flex items-center justify-center overflow-hidden">
                                    {providerSelected ? (
                                          <img src={providerSelected?.[0]?.logo_url} alt="provider" className="w-full h-full object-contain bg-white" />
                                    ) : (
                                          <span className="text-xs text-gray-400">provider</span>
                                    )}
                              </div>

                              {/* Info */}
                              <div className="flex flex-col">
                                    <div className="text-base font-medium mb-2">{providerSelected?.[0]?.name}</div>

                                    <div className="flex gap-2 flex-wrap">
                                          {selectedSatellites?.map((item, index) => (
                                                <Tag
                                                      key={index}
                                                      className="bg-[var(--neutral-700)] border-none text-white px-3 py-[2px] rounded-md"
                                                >
                                                      {item?.name}
                                                </Tag>
                                          ))}
                                    </div>
                              </div>
                        </div>
                  </div>

            </div>
      );
};

export default ProviderCard;